interface VideoPreviewProps {
  url: string | null;  // full presigned URL — null until it's been fetched
  poster?: string | null;
}

export function VideoPreview({ url, poster }: VideoPreviewProps) {
  // While the download URL is still resolving, show the extracted poster frame
  // instead of a bare spinner — the video player mounts once url is ready.
  if (!url) {
    return poster ? (
      <img src={poster} alt="" className="h-full w-full object-contain opacity-70" />
    ) : (
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-600 border-t-brand-400" />
    );
  }

  return (
    <video
      src={url}
      poster={poster ?? undefined}
      controls
      autoPlay
      className="h-full w-full object-contain shadow-2xl"
    >
      Your browser does not support the video tag.
    </video>
  );
}
